<template lang="html">
  <ul class="position-filter">
    <li :class="{ active: activePosition === 'ALL' }" @click="select('ALL')">ALL</li>

    <li
      v-if="position !== 'FLEX'"
      :class="{ active: activePosition === position }"
      v-for="{ position } in draftablePositions"
      :key="position"
      @click="select(position)"
    >
      {{ position }}
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    position: String,
  },

  data() {
    return {
      activePosition: this.position,
    };
  },

  computed: {
    ...mapGetters({
      draftablePositions: 'draft/draftablePositions',
    }),
  },

  watch: {
    position(value) {
      this.activePosition = value;
    },
  },

  methods: {
    select(position) {
      this.activePosition = position;
      this.$emit('update:position', position);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .position-filter {
    display: flex;
    align-items: center;
    box-shadow: 0 8px 6px -6px $gray-color;

    li {
      flex: 1;
      padding: $gp $gp / 4;
      text-align: center;
      cursor: pointer;
      border-bottom: 5px solid transparent;

      &:hover {
        background-color: $gray-color-lighter;
      }

      &:active {
        background-color: $gray-color-light;
      }

      &.active {
        border-color: $primary-color;
      }
    }
  }
</style>
